<template>
    <section>
        <!-- <div class="ibox-title">
            <h5>No Of Branches ({{branches.length}})</h5>
        </div>      -->
        <div>
            <h5>No Of Branches ({{branches.length}})</h5>
            <table class="table table-striped table-responsive table-bordered">
                <thead>
                    <tr>
                        <!-- <th>ID</th> -->
                        <th>Area</th>
                        <th>City</th>
                        <th>Phone No# 1</th>
                        <th>Phone No# 2</th>
                        <th>Phone No# 3</th>
                        <th>Delivery Radius</th>
                        <th>Minimum Order</th>
                        <th>Free Delivery</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="white-space: nowrap" v-for="(branch, index) in branches"  v-bind:key="index+'_branch'">
                        <!-- <td><a @click="openBranchPopup(branch.id, selectedRestaurant.id, selectedRestaurant.name)">{{branch.id}}</a></td> -->
                        <td>{{branch.areasByAreaId.name}}</td>
                        <td>{{branch.areasByAreaId.citiesByCityId.city}}</td>
                        <td>{{branch.phone1}}</td>
                        <td>{{branch.phone2}}</td>
                        <td>{{branch.phone3}}</td>
                        <td>{{branch.deliveryRadius}} KM</td>
                        <td>{{branch.minimumOrder}}</td>
                        <td>{{(branch.freeDelivery===true) ? "Yes" : "No"}}</td>
                    </tr>                                    
                </tbody>
            </table>
        </div>
        <AddUpdateBranch ref="addUpdateBranchPopUp" />
    </section>
</template>

<script>
    import AddUpdateBranch from '@/components/restaurants/AddUpdateBranch'
    export default {
        name: "AllBranchesOfRestaurants",
        props:["selectedRestaurant","branches"],
        data () {
            return {
            }
        },
        components: {
            AddUpdateBranch
        },           
        methods:{
            openBranchPopup: function(branchId, restaurantId, restaurantName) {
                this.$refs.addUpdateBranchPopUp.load(branchId, restaurantId, restaurantName);
            }
        }
    }
</script>